import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=f88bf666"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=f88bf666&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports